import { render, staticRenderFns } from "./QuickImport.vue?vue&type=template&id=224b270c&"
import script from "./QuickImport.vue?vue&type=script&lang=js&"
export * from "./QuickImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports